import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { UserAttributesClient } from 'frontend-preferences-client';
import { FORECASTING_ACCESS } from '../constants/Scopes';
import { HAS_SEEN_DEAL_STAGE_TOUR_SETTING, HAS_SEEN_FMO_MIGRATION_TOUR_SETTING } from '../constants/SettingsTypes';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
import { queryQuickFetch } from './earlyRequestHelper';
const USERS_URI_V2 = 'users/v2';
const userAttributesClient = UserAttributesClient.forCaller('forecasting-ui');
export const fetchUsers = () => queryQuickFetch(EARLY_REQUESTER_KEYS.USERS, () => http.get(`${USERS_URI_V2}/app/scopes/${FORECASTING_ACCESS}/hubs/${PortalIdParser.get()}/hub-users`));
export const fetchHasSeenDealStageTourSetting = () => userAttributesClient.fetch(HAS_SEEN_DEAL_STAGE_TOUR_SETTING, 'false', EARLY_REQUESTER_KEYS.USER_ATTRIBUTES);
const KEYS_TO_FETCH = {
  [HAS_SEEN_DEAL_STAGE_TOUR_SETTING]: 'false',
  [HAS_SEEN_FMO_MIGRATION_TOUR_SETTING]: 'false'
};
export const fetchHasSeenTourSettings = () => userAttributesClient.batchFetch(KEYS_TO_FETCH, EARLY_REQUESTER_KEYS.USER_ATTRIBUTES);
const setHasSeenTourSetting = (attributeName, hasSeen) => userAttributesClient.write(attributeName, JSON.stringify(hasSeen));
export const setHasSeenDealStageTourSetting = hasSeen => setHasSeenTourSetting(HAS_SEEN_DEAL_STAGE_TOUR_SETTING, hasSeen);
export const setHasSeenFmoAdminMigrationTourSetting = hasSeen => setHasSeenTourSetting(HAS_SEEN_FMO_MIGRATION_TOUR_SETTING, hasSeen);
export const fetchTeams = () => queryQuickFetch(EARLY_REQUESTER_KEYS.TEAMS, () => http.get('/app-users/v1/teams'));